export const getSchema = ({
  t,
  outcomeReasons,
}: {
  t: (id: string, obj?: Object) => string,
  outcomeReasons: Array<Object>,
}) => {
  return {
    type: "object",
    required: ["hearingDate", "hearingChairedBy", "hrRepresentative", "appealOutcome", "rationale"],
    properties: {
      hearingDate: {
        type: "string",
        title: t("HEARING_DATE"),
        format: "date-time",
      },
      hearingChairedBy: {
        type: "number",
        title: t("HEARING_CHAIRED_BY"),
      },
      hrRepresentative: {
        type: "number",
        title: t("HR_REPRESENTATIVE"),
      },
      appealOutcome: {
        type: "string",
        title: t("APPEAL_OUTCOME_REASON"),
        oneOf: [
          {
            title: t("UPHELD"),
            const: "UPHELD",
          },
          {
            title: t("NOT_UPHELD"),
            const: "NOT_UPHELD",
          },
        ],
      },
      rationale: {
        type: "object",
        required: ["id"],
        title: t("RATIONALE"),
        properties: {
          id: {
            type: "integer",
            title: t("RATIONALE"),
            oneOf: outcomeReasons
              .filter(el => el.isActive)
              .map(reason => ({
                title: reason.name,
                const: reason.id,
              })),
          },
        },
      },
      documents: {
        type: "array",
        title: t("ATTACH_DOCUMENT"),
        items: {
          type: "string",
        },
      },
    },
    urn: "urn:jsonschema:eu:firstcare:api:v1:dto:tools:tasks:HearingsReviewDTO",
  };
};
